export default __webpack_public_path__ + "static/Rectangle-312-e1e95240ddb87149c8dc93bce89b486a.jpg";